import { FC } from 'react';
import { cn } from '../../utils/cn';

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'default';

interface StatusBadgeProps {
  status: string;
  variant?: BadgeVariant;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  success: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300',
  warning: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300',
  error: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300',
  info: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300',
  default: 'bg-gray-100 dark:bg-slate-700 text-gray-800 dark:text-slate-300',
};

// Map common status values to variants
const statusVariantMap: Record<string, BadgeVariant> = {
  // Booking statuses
  CONFIRMED: 'success',
  COMPLETED: 'success',
  PENDING_PAYMENT: 'warning',
  CANCELLED: 'error',
  NO_SHOW: 'error',
  // Active/Inactive
  active: 'success',
  inactive: 'default',
  // Payment statuses
  SUCCEEDED: 'success',
  PENDING: 'warning',
  FAILED: 'error',
  REFUNDED: 'info',
};

export const StatusBadge: FC<StatusBadgeProps> = ({ status, variant, className }) => {
  const resolvedVariant = variant || statusVariantMap[status] || 'default';
  const displayStatus = status.replace(/_/g, ' ');

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variantStyles[resolvedVariant],
        className
      )}
    >
      {displayStatus}
    </span>
  );
};
